import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-mobile-datepicker";

export default function ComponentDateTimePicker(props) {
  const { t } = useTranslation();

  const normalizeDate = (value) => {
    if (!value) {
      return new Date();
    }

    const parsed = value instanceof Date ? new Date(value) : new Date(String(value));
    if (Number.isNaN(parsed.getTime())) {
      return new Date();
    }
    return parsed;
  };

  const dateTime = useMemo(() => {
    const value = normalizeDate(props.value);
    value.setSeconds(0);
    value.setMilliseconds(0);
    return value;
  }, [props.value]);

  const maxDateTime = useMemo(() => {
    const max = normalizeDate(props.value);
    max.setFullYear(max.getFullYear() + 10);
    return max;
  }, [props.value]);

  const minDateTime = useMemo(() => {
    const min = normalizeDate(props.value);
    min.setFullYear(min.getFullYear() - 10);
    return min;
  }, [props.value]);

  return (
    <DatePicker
      isOpen={props.open}
      showCaption
      onCancel={props.cancel}
      onSelect={(value) => props.confirm(normalizeDate(value))}
      theme="dark"
      headerFormat="DD-MM-YYYY HH:mm"
      confirmText={t("confirm")}
      cancelText={t("cancel")}
      value={dateTime}
      min={minDateTime}
      max={maxDateTime}
      dateConfig={{
        year: {
          format: "YYYY",
          caption: t("year"),
          step: 1
        },
        month: {
          format: "MM",
          caption: t("month"),
          step: 1
        },
        date: {
          format: "DD",
          caption: t("day"),
          step: 1
        },
        hour: {
          format: "HH",
          caption: t("hour"),
          step: 1
        },
        minute: {
          format: "mm",
          caption: t("minute"),
          step: 15
        }
      }}
    />
  );
}
